import ENUM from '../ENUM'

export default {
    kind: 'DerivedImportanceSlide',
    filters: [
        {
            name: ENUM().removeBaseLimit,
        },
    ],
    references: [ENUM().pageQuestionId, ENUM().kpiPageQuestionId, ENUM().removeBaseLimit],
}
